export function formatoImporte(valor) {
  if (valor == null || valor === "") return "";
  const num =
    typeof valor === "number"
      ? valor
      : Number(String(valor).replace(",", "."));
  if (!Number.isFinite(num)) return String(valor);
  return num.toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
